export type PlannedMaterialEntry = {
  place: string
  varieties: string[]
}

export const RosePlanCard: React.FC<{ entries: PlannedMaterialEntry[] }> = ({ entries }) => (
  <div className="bg-white rounded-2xl px-8 py-10 w-full flex flex-col gap-6 items-center">
    <div className="flex flex-col gap-2 items-center text-center">
      <p className="text-[13px] font-medium text-accent tracking-[0.02em]">次は何が届く？</p>
      <h3 className="text-[20px] font-bold text-black leading-normal">いま狙ってる品種リスト</h3>
    </div>
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col gap-4 w-full">
        {entries.map(({ place, varieties }) => (
          <div key={place} className="flex flex-col gap-2">
            <p className="text-[13px] font-bold text-black">{place}</p>
            <div className="flex flex-wrap gap-1.5">
              {varieties.map((variety) => (
                <span key={variety} className="bg-[#f9f9f9] rounded-md px-2 py-1 text-[12px] font-medium text-[#858585]">
                  {variety}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="text-[11px] text-[#666666] leading-normal tracking-[0.02em] space-y-1">
        <p>※単品種のみ、または品種ミックスでお届けします。</p>
        <p>※仕入れ状況により、記載された品種以外のものをお届けする場合がございます。あらかじめご了承ください。</p>
      </div>
    </div>
  </div>
)
